import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export const useStyles = () => {
  const theme = useTheme();
  const isXSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmall = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMedium = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const getModalWidth = () => {
    if (isXSmall) return "90%"; // For extra small devices
    if (isSmall) return "70%"; // For small devices
    if (isMedium) return "50%"; // For medium devices
    if (isLarge) return "30%"; // For large devices
    return "50%"; // Default
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: getModalWidth(),
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    margin: "auto",
    overflow: "scroll",
    maxHeight: "100%",
  };

  return { modalStyle };
};

export interface AddressSuggestion {
  place_id: string;
  description: string;
}

export interface FullAddress {
  [key: string | "street" | "city" | "zipcode" | "state" | "country" | "bulding"]: string;
}

export interface AddressSuggestion {
  place_id: string;
  description: string;
}
